import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { colors, fontFamily, maxWidth } from "./tokens";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(7, 3, 4),
    background: colors.ink,
    borderTop: "1px solid rgba(255,255,255,0.08)"
  },
  inner: {
    maxWidth,
    margin: "0 auto"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)"
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr"
    }
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: 9,
    fontFamily,
    fontWeight: 700,
    fontSize: 18,
    color: "#fff",
    marginBottom: theme.spacing(1.5)
  },
  logoMark: {
    height: 24,
    width: "auto",
    display: "block"
  },
  tagline: {
    fontFamily,
    fontSize: 13,
    color: "rgba(255,255,255,0.5)",
    maxWidth: 220,
    lineHeight: 1.6
  },
  colTitle: {
    fontFamily,
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "rgba(255,255,255,0.4)",
    marginBottom: theme.spacing(2)
  },
  link: {
    display: "block",
    fontFamily,
    fontSize: 13.5,
    color: "rgba(255,255,255,0.7)",
    textDecoration: "none",
    marginBottom: theme.spacing(1.25),
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#fff"
    }
  },
  bottom: {
    borderTop: "1px solid rgba(255,255,255,0.08)",
    paddingTop: theme.spacing(3),
    fontFamily,
    fontSize: 12.5,
    color: "rgba(255,255,255,0.4)"
  }
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <div className={classes.grid}>
          <div>
            <div className={classes.logo}>
              <img
                src={toAbsoluteUrl("/media/client-logos/logo.png")}
                alt=""
                className={classes.logoMark}
              />
              ANIKE
            </div>
            <p className={classes.tagline}>
              Asset maintenance, managed in one connected platform.
            </p>
          </div>

          <div>
            <div className={classes.colTitle}>Product</div>
            <a className={classes.link} href="#capabilities">Assets &amp; Sites</a>
            <a className={classes.link} href="#capabilities">Service Requests &amp; Work Orders</a>
            <a className={classes.link} href="#capabilities">Inventory &amp; Procurement</a>
            <a className={classes.link} href="#capabilities">Reporting &amp; Insights</a>
          </div>

          <div>
            <div className={classes.colTitle}>Account</div>
            <a className={classes.link} href="/auth/login">Sign In</a>
            <a className={classes.link} href="/auth/registration">Get Started</a>
          </div>

          <div>
            <div className={classes.colTitle}>Company</div>
            <a className={classes.link} href="/help">Help &amp; Guides</a>
            <a className={classes.link} href="/terms-and-conditions">Terms &amp; Conditions</a>
            <a className={classes.link} target="_blank" rel="noopener noreferrer" href="https://apexapps.net/contacts.php">Contact</a>
          </div>
        </div>

        <div className={classes.bottom}>
          &copy; {new Date().getFullYear()} ANIKE. Powered by Apex Applications. All rights reserved. 
        </div>
      </div>
    </footer>
  );
}
